<template>
  <div>
    <layout-head v-if="code === '001'" :navActive="2"></layout-head>
    <layout-head v-if="code === '002'" :navActive="4"></layout-head>
    <layout-head v-if="code === '003'" :navActive="1"></layout-head>
    <layout-head v-if="code !== '001' && code !== '002' && code !== '003'" :navActive="0"></layout-head>
    <div class="topic_list_container">
      <div class="warp12">
        <div class="topic_list_nav">
          <div class="bread">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item v-if="code === '001'" :to="{ path: '/multimedia' }">多媒体矩阵</el-breadcrumb-item>
              <el-breadcrumb-item v-if="code === '002'" :to="{ path: '/pictorialMatter' }">解图知事</el-breadcrumb-item>
              <el-breadcrumb-item v-if="code === '003'" :to="{ name: 'topic', query: { code: '003' } }">专家讲堂</el-breadcrumb-item>
              <el-breadcrumb-item>专题列表</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="search_container">
            <el-input v-model.trim="searText" placeholder="搜索你想知道的" @keyup.enter.native="checkList"></el-input>
            <img src="@/assets/image/index/search_btn.png" alt class="search_btn" @click="checkList" />
          </div>
        </div>
        <div class="topic_type_list" v-if="pageType === 1">
          <div :class="topicIndex == '全部' ? 'type_item active' : 'type_item'" @click="changeType('全部')">全部</div>
          <div :class="item == topicIndex ? 'type_item active' : 'type_item'" v-for="(item, index) in topicType" :key="index"
            @click="changeType(item)">{{ item }}</div>
        </div>
        <div class="topic_type_list" v-if="pageType === 2">
          <div :class="newhotIndex == '全部' ? 'type_item active' : 'type_item'" @click="changeNewhotType('全部')">全部</div>
          <div :class="index == newhotIndex ? 'type_item active' : 'type_item'" v-for="(item, index) in newhotType"
            :key="index" @click="changeNewhotType(index)">{{ item.title }}</div>
        </div>
        <div class="topic_list" v-if="topicList.length > 0">
          <div class="topic_item" v-for="(item, index) in topicList" :key="index" @click="goDetails(code, item)">
            <img :src="item.coverUrl" class="topic_item_img" alt="">
            <div class="topic_item_bottom">
              <h4 :title="item.fileName">{{ item.fileName }}</h4>
              <div class="tip">
                <span>{{ item.theme }}</span>
                <span v-if="code === '001'">{{ item.duration.slice(0, 8) }}</span>
              </div>
              <div class="ll">
                <p v-if="code !== '003'"><img src="@/assets/image/multimedia/chakan.png" alt="">{{ item.visitCount }}</p>
                <p v-else></p>
                <p>{{ item.updateTime }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="no_data" v-if="topicList.length === 0">
          <el-empty :image-size="200"></el-empty>
        </div>
        <div class="pagination" v-if="total > 0">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :hide-on-single-page="1"
            :page-size="pageSize" prev-text="上一页" next-text="下一页" layout="prev, pager, next, jumper,total"
            :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <layout-footer></layout-footer>
  </div>
</template>

<script>
import layoutHead from '@/components/Header'
import layoutFooter from '@/components/Footer'
import { getData, getTypeData } from '../../assets/js/api'
export default {
  name: 'topicListPage',
  components: { layoutHead, layoutFooter },
  data () {
    return {
      searText: '',
      topicIndex: '全部',
      topicType: [],
      newhotType: [
        { title: '最新推荐', orderBy: 'updateTime' },
        { title: '最热榜单', orderBy: 'visitCount' }
      ],
      newhotIndex: '全部',
      pageType: 1, // 1分类 2最热最新
      topicList: [],
      currentPage: 1,
      total: 0,
      pageSize: 12,
      code: ''
    }
  },
  watch: {
    $route: {
      handler (route) {
        this.code = this.$route.query.code
        if (this.$route.query.searText) {
          this.searText = this.$route.query.searText
        }
        if (this.$route.query.item || this.code === '003') {
          this.pageType = 1
          if (this.code === '003') {
            this.topicIndex = '全部'
          } else {
            this.topicIndex = this.$route.query.item
          }
          this.getTypeList()
          this.getList(1, this.topicIndex)
        } else if (this.$route.query.type) {
          this.pageType = 2
          this.type = this.$route.query.type
          this.getHotNewList(1, this.$route.query.type)
          // eslint-disable-next-line no-empty
        } else {

        }
      }
    }
  },
  created () {
    this.code = this.$route.query.code
    if (this.$route.query.searText) {
      this.searText = this.$route.query.searText
    }
    if (this.$route.query.item || this.code === '003') {
      this.pageType = 1
      if (this.code === '003') {
        this.topicIndex = '全部'
      } else {
        this.topicIndex = this.$route.query.item
      }
      this.getTypeList()
      this.getList(1, this.topicIndex)
    } else if (this.$route.query.type) {
      this.pageType = 2
      this.type = this.$route.query.type
      this.getHotNewList(1, this.$route.query.type)
      // eslint-disable-next-line no-empty
    } else {

    }
  },
  methods: {
    handleCurrentChange (val) {
      if (this.$route.query.item || this.code === '003') {
        this.getList(val, this.topicIndex)
      } else if (this.$route.query.type) {
        this.getHotNewList(val, this.type)
        // eslint-disable-next-line no-empty
      } else { }

      console.log(`当前页: ${val}`)
    },
    getTypeList () {
      getTypeData({ code: this.code }).then((res) => {
        if (res.code === '200') {
          this.topicType = res.content
        }
      })
    },
    getList (page, item) {
      // eslint-disable-next-line prefer-const
      let params = {
        code: this.code,
        size: this.pageSize,
        current: page
      }
      if (item !== '全部') {
        params.theme = item
      }
      if (this.searText !== '') {
        console.log(this.searText)
        params.fileName = this.searText.substr(0, 100)
      }
      getData(params).then((res) => {
        if (res.code === '200') {
          this.topicList = res.content.data
          this.total = res.content.total
        } else {
          this.topicList = []
          this.total = 0
        }
      })
    },
    getHotNewList (page, type) {
      const params = {
        code: this.code,
        size: this.pageSize,
        current: page
      }
      if (type === 'new') {
        params.orderBy = 'updateTime'
        this.newhotIndex = 0
      } else if (type === 'hot') {
        params.orderBy = 'visitCount'
        this.newhotIndex = 1
      }
      if (this.searText !== '') {
        params.fileName = this.searText.substr(0, 100)
      }
      getData(params).then((res) => {
        if (res.code === '200') {
          this.topicList = res.content.data
          this.total = res.content.total
        } else {
          this.topicList = []
          this.total = 0
        }
      })
    },

    changeType (item) {
      this.topicIndex = item
      this.currentPage = 1
      this.getList(1, this.topicIndex)
    },
    changeNewhotType (index) {
      this.newhotIndex = index
      if (index === '全部') {
        this.type = 'all'
      } else if (index === 0) {
        this.type = 'new'
      } else if (index === 1) {
        this.type = 'hot'
      }
      this.currentPage = 1
      this.getHotNewList(1, this.type)
    },
    goDetails (code, item) {
      if (code === '003') {
        window.open(item.videoUrl, '_blank')
      } else {
        this.$router.push({
          name: 'topicDetails',
          query: {
            id: item.fileID,
            code: code
          }
        })
      }
    },
    checkList () {
      this.currentPage = 1
      if (this.$route.query.item || this.code === '003') {
        // this.topicIndex = '全部'
        this.getList(1, this.topicIndex)
      } else if (this.$route.query.type) {
        // this.type = '全部'
        this.getHotNewList(1, this.type)
        // eslint-disable-next-line no-empty
      } else { }
    }
  }
}
</script>

<style lang="less" scoped>
.topic_list_container {
  margin-top: -387px;

  .topic_list_nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 48px;

    .bread {}

    .search_container {
      width: 342px;
      margin: 0;
    }
  }

  .topic_type_list {
    display: flex;
    align-items: center;
    padding: 0 17px;
    margin-bottom: 62px;

    .type_item {
      width: 120px;
      height: 55px;
      background: #ffffff;
      border-radius: 5px;
      text-align: center;
      line-height: 55px;
      font-size: 17px;
      color: #1c55f1;
      margin-right: 10px;
      cursor: pointer;
      text-align: center;

      &.active,
      &:hover {
        background: #ffcc1b;
        color: #ffffff;
      }
    }
  }

  .topic_list {
    display: flex;
    flex-wrap: wrap;
    min-height: 300px;

    .topic_item {
      width: 280px;
      height: 232px;
      background: #FFFFFF;
      border: 1px solid #FFFFFF;
      box-shadow: 0px 0px 20px 0px rgba(2, 39, 102, 0.2);
      margin-bottom: 32px;
      margin-right: 26px;
      cursor: pointer;

      .topic_item_img {
        display: block;
        width: 100%;
        height: 130px;
      }

      .topic_item_bottom {
        padding: 14px;

        h4 {
          color: #333333;
          font-size: 16px;
          line-height: 26px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .tip {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 5px;
          color: #666666;
          font-size: 12px;
          line-height: 26px;
        }

        .ll {
          display: flex;
          justify-content: space-between;
          align-items: center;

          p {

            font-size: 13px;
            color: #666666;

            img {
              display: inline-block;
              vertical-align: middle;
              margin-right: 8px;
            }
          }
        }
      }

      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}
.no_data {
  height: 336px;
}
</style>
